import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GlobalConstants } from '../../../../../src/app/common/constants/global.constant';
import { Subject } from 'rxjs/internal/Subject';
import { BannerContent } from '../../asset-library/banner-carousel/interface/banner-carousel.i';
import { DevicesConstants } from '../../../core/routing/services/devices/constants/devices.constants';
import { DeviceStoreService } from '../store/device.store';
import { BannerCarousel } from '../interface/devices-interface.i';
import { GoogleAnalyticsService } from '../../../../app/modules/google-analytics/google-analytics.service'
import { AppGlobal } from '../../../../app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';

@Component({
  selector: 'iposcen-device-banner-carousel',
  templateUrl: './device-banner-carousel.component.html',
  styleUrls: ['./device-banner-carousel.component.scss']
})
export class DeviceBannerCarouselComponent implements OnInit {

  isCollapsed = true;
  bannerActive = true;
  @Input() selectLength;
  @Output() readonly lastUpdateTime = new EventEmitter();
  cancelBtn = GlobalConstants.CANCEL;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  buttonLabelNo = DevicesConstants.NO;
  saveChanges = GlobalConstants.SAVE_CHANGES;
  cancelChanges = GlobalConstants.CANCEL;
  successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
  description = DevicesConstants.DEVICE_UPDATE_DESC;
  allBannerCarousel: BannerContent[];
  bannerCarousel: BannerCarousel[];
  bannerCarouselId: string;
  deviceInfoForm: FormGroup;
  selctedBannerCarouselGroup: any = {
    selectedCG: []
  };
  activeBannerList: any;
  activeBannerCarouseltList: any;
  isCancel = false;
  openModalPopup = false;
  openSuccessPopup = false;
  bannerPayload;
  bannerData = new Map();
  checkIfEnabeled = new Map();
  bannerLength = 0;
  isBannerEmpty: boolean;
  isDeviceBannerNone: boolean;
  @Output() readonly getBannerStatus = new EventEmitter();
  @Output() readonly dismissFunc = new EventEmitter();
  private ngUnsubscribe = new Subject<boolean>();
  userInfo: { email: string; userId: string; firstName: string; lastName: string; retailerName: string; role: string; retailerID: string; storeID: string; storeName: string; location: string; isCompRxtEnabled: boolean; isRemoveEnabled: boolean; configurations?: string; partnerID?: string; partnerName?: string; };
  isNonConnectedUser: boolean;

  constructor(private appGlobal: AppGlobal,private deviceStore: DeviceStoreService, private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.isDeviceBannerNone = false;
    this.googleAnalyticsService.devieInfoTabName('Banner Carousel');
    const storeData = this.deviceStore.deviceStoreData;
    if (storeData?.bannerCarousels.length == 0) this.isDeviceBannerNone = true;
    if (storeData?.bannerCarousels) {
      storeData.bannerCarousels.forEach(value => { this.checkIfEnabeled.set(value.bannerCarouselId, true); });
      this.bannerData = this.checkIfEnabeled;
    }
    this.appGlobal.$userAccount
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
        this.isNonConnectedUser = this.userInfo.role === GlobalConstants.NON_CONNECTED_USER ? true : false;
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getBannerLength(event) {
    this.isBannerEmpty = (event > 0) ? false : true;
    this.bannerLength = event;
  }

  getDataChecked(data) {
    this.bannerData = data;
    if(this.bannerData?.size > 0) {
      this.isDeviceBannerNone = false;
    }
  }

  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  sendDataToStore() {
    this.googleAnalyticsService.devieInfoChangesSaved('Banner Carousel');
    const bannerData = [];
    this.bannerData.forEach((v, k, m) => {
      bannerData.push({
        bannerCarouselId: k,
        showOnDevice: true
      });
    });
    this.bannerPayload = { bannerCarousels: bannerData };
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.deviceStore.updateDeviceData(this.bannerPayload);
    this.isCancel = false;
    this.getBannerStatus.emit(true);
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  closeModal() {
    this.openModalPopup = false;
  }

  closeSuccessModal() {
    this.openSuccessPopup = false;
  }
  removeBannerShowonDevice() {
    this.isDeviceBannerNone = true;
    this.bannerData.clear();
  }
}
